import axios from 'axios'
import router from '../../router'

const state = {
  myTestFavorite: [],
  myTestRegEstate: [],
  myTestBuyDocument: [],
  myTestQnaList: [],
  myTestQnaTran: '',
  myTestFavoriteTran: '',
  myTestCheckFavorite: '',
  myTestWithdrawTran: '',
  testDelRtn: ''
}

const getters = {
  getMyTestFavorite (state) {
    return state.myTestFavorite
  },
  getMyTestRegEstate (state) {
    return state.myTestRegEstate
  },
  getMyTestBuyDocument (state) {
    return state.myTestBuyDocument
  },
  getMyTestQnaList (state) {
    return state.myTestQnaList
  },
  getMyTestQnaTran (state) {
    return state.myTestQnaTran
  },
  getMyTestFavoriteTran (state) {
    return state.myTestFavoriteTran
  },
  getMyTestCheckFavorite (state) {
    return state.myTestCheckFavorite
  },
  getMyTestWithdraw (state) {
    return state.myTestWithdrawTran
  },
  getTestDelRtn (state) {
    return state.testDelRtn
  }
}

const mutations = {
  setMyTestFavorite (state, payload) {
    state.myTestFavorite = payload
  },
  setMyTestRegEstate (state, payload) {
    state.myTestRegEstate = payload
  },
  setMyTestBuyDocument (state, payload) {
    state.myTestBuyDocument = payload
  },
  setMyTestQnaList (state, payload) {
    state.myTestQnaList = payload
  },
  setMyTestQnaTran (state, payload) {
    state.myTestQnaTran = payload
  },
  setMyTestFavoriteTran (state, payload) {
    state.myTestFavoriteTran = payload
  },
  setMyTestCheckFavorite (state, payload) {
    state.myTestCheckFavorite = payload
  },
  setMyTestWithdraw (state, payload) {
    state.myTestWithdrawTran = payload
  },
  setTestDelRtn (state, payload) {
    state.testDelRtn = payload
  }
}

const actions = {
  apiMyTestFavorite (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/test/mypage/getFavoriteEstate', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyTestFavorite', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiMyTestRegEstate (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/test/mypage/getMyRegEstate', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyTestRegEstate', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiMyTestBuyDocument (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/test/mypage/getBuyDocument', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyTestBuyDocument', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiMyTestQnaList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/test/mypage/getMyQnaList', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyTestQnaList', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiTranMyTestQna (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/test/mypage/tranMyQna', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setMyTestQnaTran', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiTranMyTestFavorite (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/test/mypage/tranMyFavorite', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setMyTestFavoriteTran', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiTranTestWithdraw (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/test/mypage/deleteMember', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setMyTestWithdraw', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiCheckTestFavorite (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/test/mypage/getEstateFavoriteCheck', payload)
          .then((response) => {
            // console.log(response.data)
            context.commit('setMyTestCheckFavorite', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    }
  },
  apiTestDeleteEstate (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/test/mypage/deleteEstateData', payload)
          .then((response) => {
            // console.log('deleteTran = ' + response.data)
            context.commit('setMemberDelRtn', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/Login')
            } else {
              alert('삭제가 정상적으로 처리되지 않았습니다.')
            }
            // alert(error.response.data.message)
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mypagetest.js